import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/Pon4300';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得保險單借款約定條款及重要事項告知
export function getAgreeTermsPon4300() {
    return get(`${url}/getAgreeTerms`);
}

// 取得保險單借款再購買其他商品權益說明
export function getAgreeTermsOtherCommodityPon4300() {
    return get(`${url}/getAgreeTermsOtherCommodity`);
}

// 保戶進入保單借款前，取得保單借款資訊
export function getInfoPon4300() {
    return get(`${url}/info`);
}

// 國碼
export function getMobileCodeInfoPon4300() {
    return get(`${url}/mobileCodeInfo`);
}

// 保險單借款約定條款及重要事項告知同意
export function postAgreePon4300() {
    return post(`${url}/agree`, { ...options, repeatRequestCancel: true });
}

// 保險單借款再購買其他商品權益說明同意
export function postAgreeOtherCommodityPon4300() {
    return post(`${url}/agreeOtherCommodity`, { ...options, repeatRequestCancel: true });
}

/**
 * 送出OTP資料
 * @param {String} mobileCountry 要保人行動電話-國碼
 * @param {String} mobile 要保人行動電話
 * @param {String} email 要保人email
 */
export function submitContactPon4300(data) {
    return post(`${url}/submitContact`, data, { ...options, repeatRequestCancel: true, errorDialog: false });
}

/**
 * 送出保單借款
 * @param {String} bankNo 銀行代號
 * @param {String} bankAccount 銀行帳號
 * @param {Array} pon4300List 借款保單列表
 */
export function submitPon4300(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
